import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import WredHero from "./components/WredHero";
import WredIntroSection from "./components/WredIntroSection";
import WredBenefitsSection from "./components/WredBenefitsSection";
import WredProcessSection from "./components/WredProcessSection";
import WredCtaBanner from "./components/WredCtaBanner";
import "./website-redesigning.css";

const WebsiteRedesigningPage: React.FC = () => {
  useEffect(() => {
    document.title =
      "Website Redesigning Services | WebTech Software Solutions Bangalore";
    const description =
      "WebTech is the best website redesigning company in Bangalore. Transform your outdated website with modern design, new features, and SEO-ready upgrades.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="wredesign-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <WredHero />
            <WredIntroSection />
            <WredBenefitsSection />
            <WredProcessSection />
            <WredCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default WebsiteRedesigningPage;
